const mainUrl = "/videos";

const data = [
  {
    imgUrl: mainUrl + "/lyracons.png",
    title: "Lyracons",
    description: ["1", "2", "3"],
    technologies: ["React", "TypeScript","Graphql", "Tachyons", "CSS", "VTEX", "Git", "Vtex", "NodeJS & Express"],
  },
  {
    imgUrl: mainUrl + "/Nala.png",
    title: "Nala Rocks",
    description: ["1", "2", "3"],
    technologies: [
      "Git",
      "JavaScript",
      "React",
      "Redux",
      "Styled-Components",
      "Sass",
      "Jest",
      "Material UI",
      "CSS",
    ],
  },
  {
    videoUrl: mainUrl + "/HenryFoodDemo.mp4",
    title: "Henry Food",
    description: ["1", "2", "3", "4", "5"],
    link: "https://github.com/lucae4238/PI-Food-FT14a",
    technologies: [
      "JavaScript",
      "React",
      "Redux",
      "Styled-Components",
      "PostgreSQL",
      "Sequelize",
      "NodeJS & Express",
      "CSS",
    ],
  },
  {
    videoUrl: mainUrl + "/bot_demo.mp4",
    title: "Discord Bot",
    description: ["1", "2", "3", "4"],
    link: "https://discord.com/api/oauth2/authorize?client_id=870882811895218207&permissions=0&scope=bot",
    technologies: ["JavaScript", "NodeJS & Express"],
  },
];

export default data;
